import * as React from "react";

import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

import ReactTable from "react-table";
import { Column } from "react-table";
import "react-table/react-table.css";

import i18n from "../i18n";
import { intersect, stringToArray } from "../utils";

export interface ScenariosCheckProps {
  scenarios: any[];
  isOpen: boolean;
  onClose: () => void;
}

export default class ScenariosCheck extends React.Component<
  ScenariosCheckProps
> {
  constructor(props: ScenariosCheckProps) {
    super(props);
  }
  private filterMethod = (filter: any, row: any) =>
    new RegExp(filter.value, "i").test(String(row[filter.id]));

  private columns: Column[] = [
    {
      Header: i18n.Scenarios.Check.Table.FirstScenario,
      id: "1",
      accessor: (value: any) => value.sc1.partitionKey
    },
    {
      Header: i18n.Scenarios.Check.Table.SecondScenario,
      id: "2",
      accessor: (value: any) => value.sc2.partitionKey
    },
    {
      Header: i18n.Scenarios.Check.Table.Intents,
      id: "3",
      accessor: (value: any) => value.intentClash.join(",")
    },
    {
      Header: i18n.Scenarios.Check.Table.Entities,
      id: "4",
      accessor: (value: any) => value.entitiesClash.join(",")
    },
    {
      Header: i18n.Scenarios.Check.Table.Keywords,
      id: "5",
      accessor: (value: any) => value.keywordsClash.join(",")
    },
    {
      Header: i18n.Scenarios.Check.Table.Channels,
      id: "6",
      accessor: (value: any) => value.channelsClash.join(",")
    }
  ];
  render() {
    const { isOpen } = this.props;
    return (
      <Modal isOpen={isOpen} size="lg">
        <ModalHeader>{i18n.Scenarios.Check.Title}</ModalHeader>
        <ModalBody>
          {isOpen && <ReactTable
            data={this.collisions}
            filterable={false}
            columns={this.columns}
            defaultFilterMethod={this.filterMethod}
            defaultPageSize={10}
            className="-striped -highlight"
          /> }
        </ModalBody>
        <ModalFooter>
            <Button color="primar" onClick={() => this.props.onClose()}>
                {i18n.Global.Close}
            </Button>
        </ModalFooter>
      </Modal>
    );
  }

  get collisions(): any[][] {
    const scenarios = this.props.scenarios
      .filter(s => !!s.intents && s.intents !== "*")
      .filter(s => !!s.entities && s.entities !== "*");
    let result: any[] = [];

    scenarios.forEach((sc1, index) => {
      const others = scenarios.slice(index + 1);
      const collisions = others
        .map(sc2 => {
          const sc1Intents = stringToArray(sc1.intents);
          const sc2Intents = stringToArray(sc2.intents);
          const intentClash = intersect(sc1Intents, sc2Intents);

          const sc1Entities = stringToArray(sc1.entities);
          const sc2Entities = stringToArray(sc2.entities);
          const entitiesClash = intersect(sc1Entities, sc2Entities);

          const sc1Keywords = stringToArray(sc1.keywords);
          const sc2Keywords = stringToArray(sc2.keywords);
          const keywordsClash = intersect(sc1Keywords, sc2Keywords);

          const sc1Channels = stringToArray(sc1.channels);
          const sc2Channels = stringToArray(sc2.channels);
          const channelsClash = intersect(sc1Channels, sc2Channels);

          return {
            sc1,
            sc2,
            intentClash,
            entitiesClash,
            keywordsClash,
            channelsClash
          };
        })
        .filter(
          ({ sc2, intentClash, entitiesClash, keywordsClash, channelsClash }) =>
            intentClash.length > 0 &&
            entitiesClash.length > 0 &&
            (keywordsClash.length > 0 || sc1.keywords === sc2.keywords) &&
            (channelsClash.length > 0 || sc1.channels === sc2.channels)
        );

      result = [...result, ...collisions];
    });

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/scenarios/scenarios-check.tsx